import React from 'react'

const DRCSummary = ({ comment, formik,projectRecordNumber }: any) => {
    return (
        <div>
            <h4 className='mb-4'>Summary Information</h4>
            <div className='br-gray p-2 mt-3'>
                <h5 className='mb-1 color-red'>Comments:</h5>
                <p>{comment}</p>
            </div>
        </div>
    )
}

export default DRCSummary